<template>
  <div class="header">
    <h1>管理者群組列表</h1>
    <div class="d-flex align-items-center col-9 justify-content-end">
        <!-- v-if="Object.values($store.state.userInfo.auth_data).includes('role/create')" -->
      <button
        v-if="isButtonShow('role/create')"
        @click="$router.push('/user-management/manager-permission')"
        class="btn btn-outline-primary col-5 add-que me-5"
      >
        新增管理者群組
      </button>
    </div>
  </div>
  <CRow class="my-5 fw-bold col-12 mx-auto list-title">
    <!-- <CCol xs="2" class="text-center">ID</CCol> -->
    <CCol xs="5" class="text-center text-nowrap">管理者群組</CCol>
    <CCol xs="5" class="text-center text-nowrap">說明</CCol>
    <CCol xs="2" class="text-center text-nowrap"> </CCol>
  </CRow>
  <CRow
    v-for="item in groupList"
    :key="item.name"
    class="mb-4 border list d-flex align-items-center col-12 mx-auto"
  >
    <!-- <CCol xs="2" class="text-center">{{ item.id }}</CCol> -->
    <CCol xs="5" class="text-center">{{ item.name }}</CCol>
    <CCol xs="5" class="text-center">{{ item.content }}</CCol>
    <CCol xs="2" class="d-flex align-items-center justify-content-around">
      <CButton
        v-if="isButtonShow('role/update')"
        color="light"
        component="a"
        @click="
          $router.push({
            name: 'managerPermission',
            query: {
              id: item.id,
            },
          })
        "
        class="list-btn text-nowrap"
      >
        編輯
        <img src="@/assets/icons/edit.svg" alt="" />
      </CButton>
      <CButton
        v-if="isButtonShow('role/delete')"
        color="light"
        class="list-btn text-nowrap"
        @click="deleteQue(item.id)"
      >
        刪除
        <img src="@/assets/icons/delete.svg" alt="" />
      </CButton>
    </CCol>
  </CRow>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import router from '@/router'
import usePermission from '@/composables/usePermission'
import MsgBox from '@/components/MsgBox.vue'
import { ref } from '@vue/reactivity'
import { formatDate } from '@/utils/format-date.js'
import MessageBox from '@/plugins/MessageBox'
import { manualToggleLoading } from '@/plugins/LoadingSpinner'
import { useStore } from 'vuex'

export default {
  components: {
    MsgBox,
  },
  setup() {
    const { get_group_list, remove_group } = usePermission()
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const groupList = ref([])
    const store = useStore()
    const getList = async () => {
      manualToggleLoading(true)
      const res = await get_group_list()
      if (res.error) {
        manualToggleLoading(false)
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        manualToggleLoading(false)
        groupList.value = res.ret.data
      }
    }
    getList()
    const isButtonShow = (key)=>{
      if(store.state.userInfo.auth_data === true){
        return true
      }else{
        return Object.values(store.state.userInfo.auth_data).includes(key)
      }
    }
    const formatTimestamp = (timestamp) => {
      return formatDate(timestamp * 1000)
    }
    const deleteQue = async (id) => {
      MessageBox({
        message: '刪除後無法復原，您確定要刪除此管理者群組？',
        onConfirm: async () => {
          const res = await remove_group({ id: id })
          if (!res.error) {
            location.reload()
          } else {
            showMsgBox.value = true
            errorMsg.value = res.msg
            errorCode.value = res.error
          }
        },
      })
    }
    const toPreview = (info) => {
      const routeData = router.resolve({
        path: `/preview/${info?.id}/${info?.subjects_info[0].part_id}`,
      })
      window.open(routeData.href, '_blank')
    }

    return {
      groupList,
      formatTimestamp,
      showMsgBox,
      errorMsg,
      errorCode,
      deleteQue,
      toPreview,
      isButtonShow
    }
  },
}
</script>
<style lang="scss" scoped>
.title-wrapper {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1%;
  box-shadow: rgb(69 69 69 / 15%) 0px 1px 4px 0px;
  margin: 0 0 10px 0;
  img {
    width: 100px;
  }
}
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}
h3 {
  font-size: 22px;
  margin: 0 20px 0;
}
.que-btn {
  height: 150px;
  box-shadow: 0 1px 4px 0 rgb(69 69 69 / 20%), 0 1px 2px 0 rgb(69 69 69 / 10%);
  border-radius: 4px;
}
.list-title {
  font-size: 14px;
}
.list {
  height: 48px;
  border-radius: 20px;
}
.state {
  border-radius: 4px;
  color: #fff;
  width: 64px;
  height: 24px;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin: auto;
  justify-content: center;
}
.result {
  font-size: 12px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  white-space: nowrap;
}
.list-btn {
  font-size: 12px;
  display: flex;
  align-items: center;
  width: 64px;
  height: 24px;
  img {
    width: 16px;
    margin-left: 5px;
  }
}
.list-tips {
  cursor: no-drop;
}
.add-que {
  background: #d1e5ef;
  border-radius: 20px;
  height: 50px;
}
</style>
